import React, { useState } from "react";

import Header from "./Invoice/Header";
import Body from "./Invoice/Body";
import Footer from "./Invoice/Footer";

export default function Invoice({ invoice }) {
  return (
    <div className="payment_invoice-block">
      <div
        className={`payment_invoice ${
          invoice.attributes.paid ? "" : "payment_invoice-unpaid"
        } `}
      >
        <Header invoice={invoice} />
        <Body invoice={invoice} />
        <Footer invoice={invoice} />
      </div>
    </div>
  );
}

